function exclusiveAssign<T extends object, U extends object>(target: T, source: U): T & U {
  if (target == null) {
    throw new TypeError("Target cannot be null or undefined");
  }
  const to = Object(target);

  if (source != null) {
    const sourceKeys = Object.keys(source) as (keyof typeof source)[];
    const targetKeys = Object.keys(to) as (keyof typeof to)[];

    for (const key of targetKeys) {
      !sourceKeys.some((k) => k === key) && (to[key] = undefined);
    }

    for (const key of sourceKeys) {
      (to as any)[key] = source[key];
    }
  }

  return to as T & U;
}

(globalThis as any).exclusiveAssign = exclusiveAssign;
